import queryString from "querystring";

export const getValues = (query) => {
    query = query.replace("?", "");
    const values = queryString.parse(query);
    return values;
};

export const stringifyAndMergeValues = (query, values) => {
    const oldValues = getValues(query);
    const newValues = Object.assign(oldValues, values);
    return "?" + queryString.stringify(newValues);
};

export const stringifyAndReplaceValues = (values) => {
    return "?" + queryString.stringify(values);
};

export const checkForXSS = (queryString = "/") => {
    let matchFound = false;
    let dangerousScript = [
        "javascript",
        "<",
        "http",
        "https",
        "script",
        "www.",
    ];
    matchFound = dangerousScript.filter((x) =>
        queryString.includes(x.toLowerCase())
    ).length
        ? true
        : false;
    return matchFound ? "/" : queryString;
};

export const safeRedirect = (returnUrl) => {
    try {
        const url = new URL(returnUrl, window.location.origin);
        if (url.origin === window.location.origin) {
            window.location.href = url.href;
        } else {
            console.warn("Blocked external redirect url:", returnUrl);
            window.location.href = "/";
        }
    } catch (e) {
        console.warn("Error with the redirect url:", returnUrl);
        window.location.href = "/";
    }
};
